// extracted by mini-css-extract-plugin
export default {"root":"Header_root__fI5Bh","logo":"Header_logo__qLZnL"};